/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type UserResetPasswordInput = {
    username: string;
    clientMutationId?: string | null;
};
export type ResetUserPasswordMutationVariables = {
    input: UserResetPasswordInput;
};
export type ResetUserPasswordMutationResponse = {
    readonly userResetPassword: {
        readonly clientMutationId: string | null;
        readonly cellNumber: string;
    } | null;
};
export type ResetUserPasswordMutation = {
    readonly response: ResetUserPasswordMutationResponse;
    readonly variables: ResetUserPasswordMutationVariables;
};



/*
mutation ResetUserPasswordMutation(
  $input: UserResetPasswordInput!
) {
  userResetPassword(input: $input) {
    clientMutationId
    cellNumber
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserResetPasswordPayload",
    "kind": "LinkedField",
    "name": "userResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cellNumber",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetUserPasswordMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetUserPasswordMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d8b2e6e22918a233e432c6a75e8d058f",
    "id": null,
    "metadata": {},
    "name": "ResetUserPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation ResetUserPasswordMutation(\n  $input: UserResetPasswordInput!\n) {\n  userResetPassword(input: $input) {\n    clientMutationId\n    cellNumber\n  }\n}\n"
  }
};
})();
(node as any).hash = 'eb1e0ef46926a5c899319f9095e07af0';
export default node;
